import { Icon20DeleteOutline } from '@vkontakte/icons';
import React, { type FC, memo, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { sendDwhButton } from 'reactApp/modules/dwh/dwh.helpers';
import { SelectionsSelectors } from 'reactApp/modules/selections/selections.selectors';
import { EActions } from 'reactApp/modules/storage/storage.types';
import { moveToSafe, SafeSource } from 'reactApp/modules/trashbin/safe.helpers';
import { EToolbarItemTooltip } from 'reactApp/ui/Toolbar/Toolbar.types';
import { ToolbarItem } from 'reactApp/ui/Toolbar/ToolbarItem/ToolbarItem';

const name = 'files_to_safe';

const source = SafeSource.TRASHBIN;

export const Move2SafeButton: FC = memo(({ ...rest }) => {
    const count = useSelector(SelectionsSelectors.getSelectedIdxs)?.length;

    useEffect(() => {
        sendDwhButton({ name, source, dwh_enabled: true, dwh_enabled_fields: [['name', 'source', 'platform']] });
    }, []);

    const handleClick = useCallback(() => {
        sendDwhButton({ action: 'click', name, source, dwh_enabled: true, dwh_enabled_fields: [['name', 'source', 'platform']] });
        moveToSafe({ place: source, size: count });
    }, []);

    return (
        <ToolbarItem
            onClick={handleClick}
            id={EActions.clear}
            text="Освободить место"
            icon={<Icon20DeleteOutline data-qa-id="clear" />}
            tooltipId={EToolbarItemTooltip.move2Safe}
            {...rest}
        />
    );
});

Move2SafeButton.displayName = 'Move2SafeButton';
